exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-config-container[data-v-7b194082]{padding:20px;height:100%}", ""]);

// exports
